"use client";

import { FullScreenIcon } from "@hugeicons-pro/core-stroke-rounded";
import ControlIcon from "./ControlIcon";
import { ControlContainer, type ControlProps } from "./IconContainer";

export function GameControlsFullscreen(props: ControlProps) {
  return (
    <ControlContainer {...props}>
      <ControlIcon icon={FullScreenIcon} />
    </ControlContainer>
  );
}
